export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('vue:error', () => { //(err)
    //
  })
})